import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Typography, IconButton, Dialog, DialogTitle, DialogContent, Box, Divider, DialogActions, Button } from '@mui/material';
import AddCommentIcon from '@mui/icons-material/AddComment';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { getRemarkInfoByItemIdAPI,deleteAPI} from 'components/remark/RemarkAPI';
import RemarkEditFormImpl from '../RemarkEditFormImpl';
import { setRemarkList, deleteRemarkObj, setSelectedRemarkId } from 'store/slice/PharmaSlice';
import {setOpenCommentDialogExternal} from 'store/slice/AppSlice';


export default function RemarkListPage(maxHeight= '70vh') {
    const dispatch = useDispatch();
    const {productObj} = useSelector((state)=>state.pharmaslice.productDashboard);
    const {pharmaorderObj} = useSelector((state)=>state.pharmaslice.pharmaorderDashboard);
    const { remarkList} = useSelector((state)=>state.pharmaslice);
    const [openDialog, setOpenDialog] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const {userprofileInfo} = useSelector((state) => state.headerslice);
    const {remarkObj, selectedId} = useSelector((state) => state.pharmaslice.remarkDashboard);
    const {message} = useSelector((state) => state.headerslice);
    const [selectedRemarkId, setSelectedRemarkId1] = useState(selectedId);

    const {openCommentDialogExternal} = useSelector((state) => state.appslice);
    const {itemIdBeingComment} = useSelector((state) => state.appslice.wkflow);
   
    useEffect(() => {
        if (openCommentDialogExternal) {
            setOpenDialog(true);
            setEditMode(false);
            dispatch(setSelectedRemarkId(-1));
        }
    },[openCommentDialogExternal]);

    useEffect(() => {
        getRemarkInfoByItemIdAPI(itemIdBeingComment, () => {},
            (data) => {
                // Sort data so latest comment (by editTimestamp) is first
                const sorted = [...data].sort((a, b) => new Date(b.editTimestamp) - new Date(a.editTimestamp));
                dispatch(setRemarkList(sorted));
            }
        );
    }, [productObj.id]);
    useEffect(() => {
        setSelectedRemarkId1(selectedId);
    }, [remarkList, selectedId]);

    useEffect(() => {
        if (message) {
            //setSnackbarOpen(true);
        }
    }, [message]);
    
    const handleOpenDialog = () => {
        setEditMode(false);
        dispatch(setSelectedRemarkId(-1));
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        dispatch(setOpenCommentDialogExternal(false));
        setOpenDialog(false);
        setEditMode(false);
        dispatch(setSelectedRemarkId(-1));
    };

    const handleEditClick = (remarkId) => {
        setEditMode(true);
        dispatch(setSelectedRemarkId(remarkId));
        setOpenDialog(true);
    };

    const handleDeleteClick = (remarkId) => {
        dispatch(setSelectedRemarkId(remarkId));
        setOpenDeleteDialog(true);
    };

    const handleCloseDeleteDialog = () => {
        setOpenDeleteDialog(false);
        dispatch(setSelectedRemarkId(-1));
    };

    const handleConfirmDelete = () => {
        if (selectedRemarkId) {
            deleteAPI(selectedRemarkId, () => {
                dispatch(deleteRemarkObj(selectedRemarkId));
                setOpenDeleteDialog(false);
                setSelectedRemarkId(null);
            });
        }
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') return;
        setSnackbarOpen(false);
    };

    return (
        <Grid container sx={{ }}>
            <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography variant="h6" color="primary.darker">
                    Comments
                </Typography>
                <IconButton color="primary" onClick={handleOpenDialog} title="Add Comment">
                    <AddCommentIcon />
                </IconButton>
            </Grid>
            <Grid item xs={12} sx={{ borderRadius: 2, p: 1, maxHeight: maxHeight, overflowY: 'auto' }}>
                {remarkList && remarkList.length > 0 ? (
                    <Grid container>
                        {[...remarkList].map((remark, idx, arr) => {
                            const displayName = remark.title ? remark.title.split('@')[0] : 'Unknown';
                            let displayRole = '';
                            if (remark.rolename) {
                                const parts = remark.rolename.split('_');
                                displayRole = parts[parts.length - 1];
                            }
                            const isLast = idx === 0 && arr.length > 0; // Now first in reversed array is the latest
                            return (
                                <Grid item xs={12} key={remark.id || idx} sx={{ mb: 2 }}>
                                    <Box sx={{ backgroundColor: 'white', borderRadius: 2, p: 1, position: 'relative' }}>
                                        {/* Name, role, and date */}
                                        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                            {displayName}
                                            <span style={{ fontWeight: 400, color: '#888', marginLeft: 8 }}>
                                                {displayRole ? `(${displayRole})` : ''}
                                            </span>
                                        </Typography>
                                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.2, borderBottom: '1px solid #e0e0e0' }}>
                                            {remark.editTimestamp
                                                ? new Date(remark.editTimestamp).toLocaleString()
                                                : ''}
                                        </Typography>
                                        {/* Remark with white background */}
                                        <Box sx={{ backgroundColor: 'white', borderRadius: 1, }}>
                                            <Typography
                                                variant="h6"
                                                sx={{
                                                    fontWeight: 200,
                                                    wordBreak: 'break-word',
                                                    color: 'primary.darker',
                                                    mt: 1,
                                                    mb: 1,
                                                    whiteSpace: 'pre-line'
                                                }}
                                            >
                                                {remark.remark}
                                            </Typography>
                                            {isLast && userprofileInfo.email === remark.title && (
                                                <Box sx={{ display: 'flex', justifyContent: 'flex-end',  }}>
                                                    <IconButton size="small" color="primary" title="Edit" onClick={() => handleEditClick(remark.id)}>
                                                        <EditIcon fontSize="small" />
                                                    </IconButton>
                                                    <IconButton size="small" color="error" title="Delete" onClick={() => handleDeleteClick(remark.id)}>
                                                        <DeleteIcon fontSize="small" />
                                                    </IconButton>
                                                </Box>
                                            )}
                                        </Box>
                                    </Box>
                                </Grid>
                            );
                        })}
                    </Grid>
                ) : (
                    <Typography variant="body2" color="text.secondary" sx={{backgroundColor: 'white', borderRadius: 1 }}>
                        No remarks found.
                    </Typography>
                )}
            </Grid>
            {/* Add/Edit Remark Dialog */}
            <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 1 }}>
                    {editMode ? 'Edit Comment' : 'Add Comment'}
                    <IconButton edge="end" color="inherit" onClick={handleCloseDialog} aria-label="close">
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <RemarkEditFormImpl onClose={handleCloseDialog} selectedRemarkId={selectedRemarkId} />
                </DialogContent>
            </Dialog>
            {/* Delete Confirmation Dialog */}
            <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
                <DialogTitle>Delete Comment</DialogTitle>
                <DialogContent>
                    <Typography>Are you sure you want to delete this comment?</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDeleteDialog} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleConfirmDelete} color="error" variant="contained">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={5000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }} // Show at top center
            >
                <MuiAlert elevation={6} variant="filled" onClose={handleSnackbarClose} severity="info">
                    {message}
                </MuiAlert>
            </Snackbar>
        </Grid>
    )

}